// Oral-exam finding types — the single source of truth shared by the chart
// editor (OralExamEditor) and the Summary dashboard's Oral Exam view so the
// option list, colors, and short tooth-chart marks never drift apart.
//
// `abbr` is the short mark drawn on the odontogram (e.g. ฟันผุ → DC,
// แนะนำถอนฟัน → Ext). Keep it ≤3 chars so it fits inside a tooth cell.

// ฟันบิ่น and ฟันแตก are now one combined option (both = fracture → Fx).
export const FRACTURE_TYPE = 'ฟันบิ่น/แตก'

export const ORAL_EXAM_TYPES = [
  'ฟันผุ',
  FRACTURE_TYPE,
  'ฟันคุด',
  'หลุมร่องฟันลึก',
  'คอฟันสึก',
  'ฟันโยก',
  'แนะนำถอนฟัน',
  'แนะนำรักษารากฟัน',
  'อื่นๆ',
]

export const TYPE_META = {
  'ฟันผุ':              { abbr: 'DC',   bg: 'bg-rose-50',    text: 'text-rose-700',    ring: 'ring-rose-200',    dot: 'bg-rose-500',    mark: 'bg-rose-600' },
  [FRACTURE_TYPE]:      { abbr: 'Fx',   bg: 'bg-red-50',     text: 'text-red-700',     ring: 'ring-red-200',     dot: 'bg-red-500',     mark: 'bg-red-600' },
  'ฟันคุด':             { abbr: 'Imp',  bg: 'bg-fuchsia-50', text: 'text-fuchsia-700', ring: 'ring-fuchsia-200', dot: 'bg-fuchsia-500', mark: 'bg-fuchsia-600' },
  'หลุมร่องฟันลึก':      { abbr: 'DG',   bg: 'bg-orange-50',  text: 'text-orange-700',  ring: 'ring-orange-200',  dot: 'bg-orange-500',  mark: 'bg-orange-600' },
  'คอฟันสึก':           { abbr: 'NCCL', bg: 'bg-teal-50',    text: 'text-teal-700',    ring: 'ring-teal-200',    dot: 'bg-teal-500',    mark: 'bg-teal-600' },
  'ฟันโยก':             { abbr: 'Mob',  bg: 'bg-yellow-50',  text: 'text-yellow-700',  ring: 'ring-yellow-200',  dot: 'bg-yellow-500',  mark: 'bg-yellow-500' },
  'แนะนำถอนฟัน':        { abbr: 'Ext',  bg: 'bg-violet-50',  text: 'text-violet-700',  ring: 'ring-violet-200',  dot: 'bg-violet-500',  mark: 'bg-violet-600' },
  'แนะนำรักษารากฟัน':   { abbr: 'RCT',  bg: 'bg-indigo-50',  text: 'text-indigo-700',  ring: 'ring-indigo-200',  dot: 'bg-indigo-500',  mark: 'bg-indigo-600' },
  'อื่นๆ':              { abbr: 'Etc',  bg: 'bg-slate-100',  text: 'text-slate-700',   ring: 'ring-slate-200',   dot: 'bg-slate-400',   mark: 'bg-slate-500' },

  // Legacy stored values — kept so older records still render as Fx (red) even
  // though the picker now offers only the combined option above.
  'ฟันบิ่น':            { abbr: 'Fx',   bg: 'bg-red-50',     text: 'text-red-700',     ring: 'ring-red-200',     dot: 'bg-red-500',     mark: 'bg-red-600' },
  'ฟันแตก':             { abbr: 'Fx',   bg: 'bg-red-50',     text: 'text-red-700',     ring: 'ring-red-200',     dot: 'bg-red-500',     mark: 'bg-red-600' },
}

export function typeMeta(type) {
  return TYPE_META[type] || TYPE_META['อื่นๆ']
}
